import React,{Fragment,useContext, useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import loading_img from "../../../../images/profile/loading.gif";
import { Router, useLocation } from "react-router-dom";
import { GlobalSet } from '../../global/GlobalProvider';
//Import Components
import axios from "axios";
import { Row, Col, Card, Carousel,Accordion, Container } from 'react-bootstrap';
import nav_data from '../../../layouts/nav/NavData';
import Slider from "react-slick";
import swal from "sweetalert";
import { useTranslation, initReactI18next } from 'react-i18next';
import Youtube from "../../../../images/frontend/Youtube.png";
import Twitter from "../../../../images/frontend/Twitter.png";
import Telegram from "../../../../images/frontend/Telegram.png";
import Pinterest from "../../../../images/frontend/Pinterest.png";
import Instagram from "../../../../images/frontend/Instagram.png";
import FaceBook from "../../../../images/frontend/FaceBook.png";

const Home = () => {

  useEffect(() => {
    var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/6347175137898912e96e5014/1gf6r66b6";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);
    return () => {
      // Cleanup script if necessary
      document.body.removeChild(script);
    };
  }, []);
 const { t } = useTranslation();
  const BaseUrl = "https://backoffice.betfair75.com/";
  const  RootUrl  = "https://betfair75.com/";
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const provider = urlSearchParams.get('provider');
  let  providerGet;
  if (provider !== undefined && provider !== null && provider !== '') {
     providerGet = provider;
  }else{
     providerGet = "";
  }
 
    const [selectedOption, setSelectedOption] = useState([]);
    const [registerInput, setRegister] = useState({
        name: '',
        email: '',
        country:'',
        tel_sky: '',
        mobile_No: '',
        message: '',
        error_list: [],
    });

    const handleInput = (e) => {
        e.persist();
        setRegister({...registerInput, [e.target.name]: e.target.value });
    }

    const registerSubmit = (e) => {
        e.preventDefault();
        
        const data = {
            name: registerInput.name,
            email: registerInput.email,
            country: selectedOption.label,
            tel_sky: registerInput.tel_sky,
            message: registerInput.message,
            mobile_No: registerInput.mobile_No,
            key_s: "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",
        }
            axios.post(`/send-message-affiliate`, data).then(res => { 
                if(res.data.status === 'success')
                {
                    setRegister({...registerInput,
                      name: '',
                      email: '',
                      country: '',
                      tel_sky: '',
                      message: '',
                      mobile_No: '',
                      
                    });
                    swal("Success",res.data.message,"success");
                }
               else if(res.data.status === 'fail')
                {
                    swal("Warning",res.data.message,"warning");
                }
                else
                {
                    setRegister({...registerInput, error_list: res.data.validation_error});
                }
            });
      
    }


return(
<>
   <span>
      <div className="row">
        <div
          style={{
            backgroundImage: `url(${BaseUrl}public/appssource/frontend_img/casino-11.png)`,
            backgroundSize: "cover",
            backgroundAttachment: "fixed",
            backgroundPosition: "center",
            position: "relative",
            height: "130vh",
            width: "100%",
          }}
        >
          {/* Full black shadow overlay */}
          <div
            style={{
              position: "absolute",
              top: -2,
              left: -2,
              right: -2,
              bottom: -2,
              background: "linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 1))",
              opacity: 0.9, // Optional to control shadow intensity
            }}
          ></div>

          <div className="row" style={{ position: "relative", zIndex: 1, padding: '10px' }}>

          <Container className="p-2 mb-3">
            <Row>
              <Col xs={2} sm={1}><a href="https://facebook.com"><img src={Youtube} alt="" className="me-3 rounded" /> </a></Col>
              <Col xs={2} sm={1}><a href="https://instagram.com"><img src={Twitter} alt="" className="me-3 rounded" /> </a></Col>
              <Col xs={2} sm={1}><a href="https://pinterest.com"><img src={Telegram} alt="" className="me-3 rounded" /> </a></Col>
              <Col xs={2} sm={1}><a href="https://youtube.com"><img src={Pinterest} alt="" className="me-3 rounded" /> </a></Col>
              <Col xs={2} sm={1}><a href="https://telegram.org"><img src={Instagram} alt="" className="me-3 rounded" /> </a></Col>
              <Col xs={2} sm={1}><a href="https://telegram.org"><img src={FaceBook} alt="" className="me-3 rounded" /> </a></Col>
            </Row>
              <Col xs={2} sm={1}><a href="https://facebook.com"><img src="https://res.cloudinary.com/neotechbd/image/upload/c_scale,w_370/v1503063455/Neo-Technologies/Animation/contact-us.gif" alt="" className="me-3 rounded" /> </a></Col>
          </Container>

            <div className="container mt-7 text-black" >
              <h2>Contact Us</h2>
              <form onSubmit={registerSubmit}>
                <div className="form-group mb-3">
                  <div className="form-group">
                    <div className="form-group mb-3 col-md-12">
                      <label className="mb-1">
                        <strong>Name</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        name="name"
                        onChange={handleInput}
                        value={registerInput.name}
                      />
                      <span className="text-primary">
                        {registerInput.error_list.name}
                      </span>
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="mb-1">
                        <strong>Email</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        name="email"
                        onChange={handleInput}
                        value={registerInput.email}
                      />
                      <span className="text-primary">
                        {registerInput.error_list.email}
                      </span>
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="mb-1">
                        <strong>Phone</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Phone Number"
                        name="mobile_No"
                        onChange={handleInput}
                        value={registerInput.mobile_No}
                      />
                      <span className="text-primary">
                        {registerInput.error_list.mobile_No}
                      </span>
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="mb-1">
                        <strong>Telegram Or Skype</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Telegram Or Skype"
                        name="tel_sky"
                        onChange={handleInput}
                        value={registerInput.tel_sky}
                      />
                      <span className="text-primary">
                        {registerInput.error_list.tel_sky}
                      </span>
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label htmlFor="message">Message:</label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows="4"
                        required
                        placeholder="Enter Message"
                        onChange={handleInput}
                        value={registerInput.message}
                        style={{
                          color: "white",
                          backgroundColor: "transparent",
                        }}
                      ></textarea>
                      <style>
                        {`
                          #message::placeholder {
                            color: white;
                            opacity: 1;
                          }
                        `}
                      </style>
                    </div>
                    <span className="text-primary">
                      {registerInput.error_list.message}
                    </span>
                    <div className="text-center mt-4 col-md-3 text-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </span>
    </>
  )
}
export default Home;